import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import { themeColor } from '../Theming';
import images from '../Theming/images';
import { Path } from '../Routing';
import TapHereAnimated from './Components/TapHereAnimated';
import env from '../env';

export const MultiStepHeaderText = styled.h3`
  color: smokeBlack;
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const SubTitleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`;

const SubTitleText = styled.div`
  color: ${themeColor('darkestGrey')};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-family: Arial;
  font-weight: 400;
  width: 272px;
`;

const WhatYouNeedText = styled.div`
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20.8px;
  margin-bottom: 11px;
`;

const LinkText = styled.a`
  color: ${themeColor('black')};
  text-decoration: underline;
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 100%;
  min-height: 106px;
  margin-top: 33px;
  padding-left: 24px;
  padding-right: 24px;
`;

const IconContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 23px;
`;

const IconContentDescription = styled.div`
  color: ${themeColor('darkestGrey')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding-top: 10px;
`;

const ContentItem = styled.div`
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 37px;
`;

const StyledImage = styled.img`
  margin-top: 5px;
`;

const PartnerPluginActivateMultiStep: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    const initialHeight = window.innerHeight;

    const interval = setInterval(() => {
      const currentHeight = window.innerHeight;

      if (currentHeight < initialHeight) {
        history.push({
          pathname: Path.PluginActivationV2AlwaysAllow,
          search: location.search,
        });
      }
    }, 1500);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const messageHandler = (message: any) => {
      if (message) {
        switch (message.data?.type) {
          case 'PluginEnabled': {
            if (message.data?.givenPermission) {
              history.push({
                pathname: Path.PluginActivationV2StartShopping,
                search: location.search,
              });
            } else {
              history.push({
                pathname: Path.PluginActivationV2AlwaysAllow,
                search: location.search,
              });
            }
            break;
          }
        }
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      clearInterval(interval);
      window.removeEventListener('message', messageHandler);
    };
  }, [history]);

  return (
    <MultiStepActivationContainer
      headerText={'PartnerNewpluginsdkActivate.itvLetsActivateHeaderText'}
    >
      <TapHereAnimated />
      <SubTitleTextContainer id="upper_title_text_container">
        <SubTitleText id="upper_title_text">
          <Trans
            t={t}
            i18nKey="PartnerNewpluginsdkActivate.itvLatestVersionToActivate"
          >
            <LinkText href={env.itv_ios_appstore_link} target="_blank">
              AbsoluteText
            </LinkText>
          </Trans>
        </SubTitleText>
      </SubTitleTextContainer>
      <BodyContentContainer>
        <WhatYouNeedText>
          {t('PartnerNewpluginsdkActivate.hereWhatYouNeed')}
        </WhatYouNeedText>
        <IconContentContainer>
          <IconContentDescription>
            <ContentItem>
              1. {t('PartnerNewpluginsdkActivate.tapAA')}
            </ContentItem>
            <ContentItem>
              2. {t('PartnerNewpluginsdkActivate.tapManageExtension')}
            </ContentItem>
            <ContentItem>
              3. {t('PartnerNewpluginsdkActivate.toggleOnItv')}
            </ContentItem>
          </IconContentDescription>
          <StyledImage
            src={images.partnerpluginsdk_safari_activation_steps?.default}
            width={35.06}
            height={142}
            alt="activationSteps"
          />
        </IconContentContainer>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerPluginActivateMultiStep;
